import React from "react"
import HeroSection from "./hero-section"
import QuestionSection from "./question-section"
import ContactUs from "../home/contact-us"

const FAQs = () => {
  return (
    <>
      <HeroSection title="Frequently Asked Questions" />
      <QuestionSection />
      <ContactUs />
    </>
  )
}

export default FAQs
